export default "__VITE_ASSET__TTeJrVOA__"